import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=6503%3A16268
 *
 * @param {SvgIconProps} props - svg props
 */
export const UploadIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M21 22H3C2.72386 22 2.5 21.7761 2.5 21.5V20C2.5 19.7239 2.72386 19.5 3 19.5H21C21.2761 19.5 21.5 19.7239 21.5 20V21.5C21.5 21.7761 21.2761 22 21 22Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M5.57087 8.69057C5.25857 8.4044 5.24505 7.91657 5.54102 7.61355L11.4583 1.55537C11.7548 1.25179 12.2439 1.25447 12.537 1.56128L18.3407 7.63493C18.6233 7.93058 18.6169 8.39806 18.3263 8.68587L17.5401 9.46479C17.243 9.75917 16.7625 9.7536 16.4722 9.4524L12.9522 5.79952V15.5C12.9522 15.7761 12.7283 16 12.4522 16H11.5474C11.2713 16 11.0474 15.7761 11.0474 15.5V5.79952L7.50737 9.47332C7.22505 9.76631 6.7606 9.78075 6.46061 9.50587L5.57087 8.69057Z' fill={color}/>
        </SvgIcon>
    )
}

export default UploadIcon
